/**
 * VersionPopover — cursor-following popover shown on compartment hover in Arrange mode.
 *
 * Minimal content: compartment name (header) + one-line status:
 *   • "Wersja N z M przygotowanych" when alternatives exist
 *   • italic "Brak wersjonowania" when the compartment has a single variant
 *
 * Display-only component — no domain logic lives here.
 */

import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { HoverPopoverCard } from './HoverPopoverCard.jsx'

import styles from './VersionPopover.module.scss'

/**
 * @param {object}                   props
 * @param {object|null}              props.compartment — compartment data from product.compartments
 * @param {{x:number,y:number}|null} props.position
 * @param {boolean}                  props.isOpen
 * @param {function}                 [props.onClose]
 * @param {number}                   props.variantsTotal   — versions available for this compartment (>= 1)
 * @param {number}                   props.variantCurrent  — currently selected variant index (0-based)
 */
export function VersionPopover({
  compartment,
  position,
  isOpen,
  onClose,
  variantsTotal,
  variantCurrent,
}) {
  const { t } = useI18n()

  const header = compartment ? t(`compartments.${compartment.name_cad}`, compartment.name_cad) : ''

  const hasVariants = variantsTotal > 1

  return (
    <HoverPopoverCard
      isOpen={isOpen}
      position={position}
      onClose={onClose}
      header={header}
    >
      {hasVariants ? (
        <p className={styles.line}>
          {t('product.arrange_version_label', {
            current: variantCurrent + 1,
            total: variantsTotal,
          })}
        </p>
      ) : (
        <p className={`${styles.line} ${styles.muted}`}>
          <em>{t('product.arrange_no_variants')}</em>
        </p>
      )}
    </HoverPopoverCard>
  )
}
